"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = "address/5.0.1";
